import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { ButtonMessage, SingleButton } from '../../../../API/Buttons/models'
import { useCbuData } from '../../../../hooks/useCbuData'
import { BiInfoCircle } from 'react-icons/bi'
import { updateVariant } from '../../../../API/Buttons/Buttons'
import toast from 'react-hot-toast'
import { StaticsVariantsHelpers } from './StaticsVariantsHelpers'
import { getStaticIconName } from '../utils/utils'
import { AdminUser } from '../../../../API/AdminInfo/models'

interface Props {
    show: boolean
    onHide: () => void
    variant: ButtonMessage | null;
    buttonName: string;
    adminInfo: AdminUser | null;
    selectedButton: SingleButton | null;
}


export const EditVariantModal = ({ show, onHide, variant, buttonName, adminInfo, selectedButton }: Props) => {
    const { cbuData } = useCbuData()
    const [text, setText] = useState(variant?.text)

    const handleSave = async () => {
        if (!variant?.id) {
            return
        }

        if (!text) {
            toast.error('El texto no puede estar vacío')
            return
        }

        const response = await updateVariant({ messageId: variant?.id ?? '', text: text ?? '' })
        if (response === 'done') {
            toast.success('Variante actualizada correctamente')
            onHide()
        } else {
            toast.error('Error al actualizar la variante')
        }
    }




    useEffect(() => {
        setText(variant?.text)
    }, [variant])
    return (
        <Modal show={show} onHide={onHide} size='lg' centered>
            <Modal.Header closeButton>


                <Modal.Title>Editar Variante</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column gap-2'>
                    <div className='text-center gap-2 mb-3'>
                        <label htmlFor='text' className='text-secondary'>
                            Esta variante pertenece a
                            <span className="text-primaryy mx-1"><b>{getStaticIconName(selectedButton)}</b></span>
                        </label>
                    </div>
                    <textarea className='form-control' style={{ minHeight: '300px' }} value={text} onChange={(e) => setText(e.target.value)} />


                </div>
                <hr />
                <div className='mt-4 text-center text-secondary'>
                    <div className='d-flex align-items-center justify-content-center gap-1 text-xs'>
                        <BiInfoCircle size={15} />
                        <span className='text-center'>Puedes usar las variables en tus mensajes para que sean dinámicos, por ejemplo:</span>
                    </div>
                    <div className='mt-1 text-xs'>
                        Binvenido, el CBU es __CBU__, y el alias es __ALIAS__, estará disponible hasta las __HORA__

                    </div>
                </div>
                <div className="mt-3 text-secondary">
                    <div className="mb-2 text-primary">Variables disponibles:</div>
                    <div><code>__CBU__</code> ({cbuData?.CBU || 'Consultar CBU'})</div>
                    <div><code>__ALIAS__</code> ({cbuData?.alias || 'Consultar alias'})</div>
                    <div><code>__TITULAR__</code> ({cbuData?.titular || 'Consultar titular'})</div>
                    <div><code>__HORA__</code> ({cbuData?.hour_limit || 'Consultar'})</div>
                    <div><code>__LINK__</code> ({adminInfo?.pageLink || 'Consultar'})</div>
                    <div><code>__PASSWORD__</code> ({adminInfo?.default_users_password ?? 'hola123'})</div>
                    <StaticsVariantsHelpers selectedButton={selectedButton} />
                </div>




            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={() => {
                    handleSave()
                }}>
                    Guardar
                </Button>


            </Modal.Footer>
        </Modal>
    )
}
